var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('andes-header'),_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col px-0 py-4"},[_c('booking-search')],1)])]),_c('loading-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('andes-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }